import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { 
  Box, 
  CircularProgress, 
  Typography, 
  Container,
  Paper,
  Alert
} from '@mui/material';
import { Lock, Shield } from '@mui/icons-material';

const AdminProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkAdminAccess = async () => {
      try {
        // PROTECTION IMMÉDIATE: Vérifier la session admin local d'abord
        const adminSession = localStorage.getItem('adminSession');
        const sessionExpiry = localStorage.getItem('adminSessionExpiry');
        
        if (adminSession && sessionExpiry) {
          const now = new Date().getTime();
          if (now < parseInt(sessionExpiry)) {
            setIsAdmin(true);
            setLoading(false);
            return;
          } else {
            // Session expirée
            localStorage.removeItem('adminSession');
            localStorage.removeItem('adminSessionExpiry');
          }
        }

        // Vérifier si l'utilisateur est connecté
        const token = localStorage.getItem('token');
        if (!token) {
          setLoading(false);
          return;
        }

        // Vérifier le statut admin via l'API (avec fallback local)
        try {
          const response = await fetch('/api/auth/verify-admin', {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });

          if (response.ok) {
            const data = await response.json();
            if (data.isAdmin === true) {
              setIsAdmin(true);
              // Créer une session admin locale de 24h
              const expiry = new Date().getTime() + (24 * 60 * 60 * 1000);
              localStorage.setItem('adminSession', 'active');
              localStorage.setItem('adminSessionExpiry', expiry.toString());
            }
          } else {
            setError('Erreur de vérification des droits d\'accès');
          }
        } catch (apiError) {
          // Si l'API ne répond pas, utiliser une vérification de secours
          console.warn('API non disponible, vérification locale');
          setError('API temporairement indisponible');
        }
      } catch (err) {
        console.error('Erreur lors de la vérification admin:', err);
        setError('Erreur de connexion au serveur');
      } finally {
        setLoading(false);
      }
    };

    checkAdminAccess();
  }, []);

  // Page de chargement
  if (loading) {
    return (
      <Container maxWidth="md" sx={{ mt: 8, textAlign: 'center' }}>
        <CircularProgress size={50} />
        <Typography variant="h6" sx={{ mt: 2 }}>
          Vérification des droits d'accès...
        </Typography>
      </Container>
    );
  }

  // Rediriger vers la page de connexion admin si pas authentifié
  if (!isAdmin) {
    return <Navigate to="/admin-login" replace />;
  }

  // Utilisateur admin authentifié - afficher le contenu protégé
  return children;
};

export default AdminProtectedRoute;